import { AnimalSensitivitySelectOptions } from '@application/utils';
import { AnimalSensitivityEnum } from '@gql/graphql';
import type { BuyerAnimalFormValues } from '@presentation/components';
import { InputLabel, InputSelectField } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import { useFormikContext } from 'formik';
import type { FC } from 'react';
import { useMemo } from 'react';
import type { MtAnimalsBreederPageFormValues } from '@presentation/pages';
import type { AnimalSensitivityProps } from './types';

export const AnimalSensitivity: FC<AnimalSensitivityProps> = (props) => {
  const { disabledFields, mode } = props;
  const { setFieldValue } = useFormikContext<
    BuyerAnimalFormValues | MtAnimalsBreederPageFormValues
  >();

  const { translate } = useTranslation();

  const sensitivityIsDisabled = useMemo(() => {
    if (mode === 'view') return true;
    if (disabledFields?.sensitivities === true) return true;
    return false;
  }, [disabledFields?.sensitivities, mode]);

  const sensitivityOptions = useMemo(() => {
    return AnimalSensitivitySelectOptions(translate);
  }, [translate]);

  return (
    <>
      <InputLabel required>{translate('common.inputs.sensitivities.label')}</InputLabel>
      <InputSelectField<AnimalSensitivityEnum>
        name="sensitivities"
        disabled={sensitivityIsDisabled}
        multiple
        dismissOnClick={false}
        options={sensitivityOptions}
        onSelect={(selected, sensitivities) => {
          if (sensitivities?.includes(AnimalSensitivityEnum.NONE)) {
            if (selected.value === AnimalSensitivityEnum.NONE) {
              setFieldValue('sensitivities', [AnimalSensitivityEnum.NONE]);
              (document.activeElement as HTMLElement).blur?.();
            } else {
              setFieldValue(
                'sensitivities',
                (sensitivities as AnimalSensitivityEnum[]).filter(
                  (x) => x !== AnimalSensitivityEnum.NONE,
                ),
              );
            }
          }
        }}
      />
    </>
  );
};
